import appBreakpoints from "@/config/appBreakpoints";
import router from "@/router";

const state = {
  isTimelineOpen: window.innerWidth > appBreakpoints.lg,
  isSidebarOpen: window.innerWidth > appBreakpoints.lg,
  isRoutesListOpen: false
}

const getters = {
  isRouteDetailsOpen: (state, getters, rootState, rootGetters) => !!rootGetters['Routes/activeRoute'],
  isThereOpenedMenus: (state, getters) => {
    return state.isTimelineOpen || state.isSidebarOpen || state.isRoutesListOpen || getters.isRouteDetailsOpen
  }
}

const mutations = {
  SET_TIMELINE_OPEN_STATE(state, isTimelineOpen) {
    state.isTimelineOpen = isTimelineOpen
  },
  SET_SIDEBAR_OPEN_STATE(state, isSidebarOpen) {
    state.isSidebarOpen = isSidebarOpen
  },
  SET_ROUTES_LIST_OPEN_STATE(state, isRoutesListOpen) {
    state.isRoutesListOpen = isRoutesListOpen
  }
}

const actions = {
  setTimelineOpenState({ commit }, isTimelineOpen) {
    commit('SET_TIMELINE_OPEN_STATE', isTimelineOpen)
  },
  setSidebarOpenState({ commit }, isSidebarOpen) {
    commit('SET_SIDEBAR_OPEN_STATE', isSidebarOpen)
  },
  setRoutesListOpenState({ commit }, isRoutesListOpen) {
    commit('SET_ROUTES_LIST_OPEN_STATE', isRoutesListOpen)
  },
  closeAllMenus({ dispatch }) {
    dispatch('setTimelineOpenState', false)
    dispatch('setSidebarOpenState', false)
    dispatch('setRoutesListOpenState', false)
    dispatch('Routes/setActiveRouteId', null, { root: true })

    if (router.currentRoute.name !== 'home') {
      return router.push({ name: 'home' })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}